import Vue from 'vue';
import AppRouter from 'iceqerp-common/app-router';
// import Home from '../views/Home.vue';
import Login from '../views/Login.vue';
import authInfoMgmt from '../auth-info-mgmt-inst';
import Layout from '@/layout';

Vue.use(AppRouter);

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/erpList',
    component: Layout,
    redirect: '/erpList/index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/erpList/list.vue'),
        name: 'ErpList'
      }
    ]
  },
  {
    path: '/orderList',
    component: Layout,
    redirect: '/orderList/index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/orderList/list.vue'),
        name: 'OrderList'
      }
    ]
  },
  {
    path: '/productList',
    component: Layout,
    redirect: '/productList/index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/productList/list.vue'),
        name: 'ProductList'
      }
    ]
  },
  // {
  //   path: '/home',
  //   name: 'Home',
  //   component: Home
  // },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/forgetpassword',
    name: 'ForgetPassword',
    component: () => import('@/pages/forgetpassword/forgetpassword.vue')
  },
  {
    path: '/createaccount',
    name: 'CreateCcount',
    component: () => import('@/pages/createccount/createccount.vue')
  }
];

const router = new AppRouter({
  base: process.env.BASE_URL,
  routes
});

// router.beforeEach((to, from, next) => {
//   if (to.name !== 'Login') {
//     if (!authInfoMgmt.isSignedIn()) {
//       next({
//         name: 'Login'
//       });
//       return;
//     }
//   }
//   next();
// });

export default router;
